import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Component } from '@angular/core';

@Component({
    standalone: false,
    template: ` 
        <span
          [ngStyle]="{'color': color}"
        >
          {{ parsedValue }}
        </span>
         `,
})
export class BlackoutCountdownDaysCellRenderer implements ICellRendererAngularComp {
    color:string = 'yellow';
    // Init Cell Value
    public value!: string;
    public parsedValue!: string;
    agInit(params: ICellRendererParams): void {
        this.refresh(params);
    }
    constructor() {}

    // Return Cell Value
    refresh(params: ICellRendererParams): boolean {
        const data = params.data;
        if(data) {
            this.color = this.getTextColor(data);
            this.parsedValue = this.getParsedValue(data);
            return true;
        }
        return true;
    }


    getTextColor(dataItem) {
        const days = dataItem?.BlackoutRemainingDays;
        const inBlackout = dataItem?.InBlackout;
        const defaultColor = 'yellow';
        return !!(days > 0) ? inBlackout ? 'red' : 'green': defaultColor;
    }

    getParsedValue(dataItem) {
        let days = dataItem.BlackoutRemainingDays;
        if (days > 0) {
            days = dataItem.InBlackout ? '-' + days : '+' + days;
        }
        return days;
    }
}
